import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {InvoicesService} from "../../data/invoices.service";

@Component({
  selector: 'invoice-approve',
  templateUrl: './invoice-approve.component.html',
  styleUrls: ['./invoice-approve.component.scss']
})
export class InvoiceApproveComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private InvoicesService: InvoicesService
  ) { }

  @Input() invoice_id: number;
  @Input() invoiceNumber: string;

  @Output() onClose=new EventEmitter();
  @Output() onSuccess=new EventEmitter();

  ngOnInit(): void {
    this.addControls();
  }
  addControls() {
    this.form = this.formBuilder.group(
        {
          comments: new FormControl('' ),
        }
    );
  }
  get formControls() {
    return this.form.controls;
  }
  save() {
    let data={
      invoice_id: this.invoice_id,
      comments: this.formControls.comments.value
    }
    this.InvoicesService.approve(data).subscribe(
        ()=>{},
        (error: any)=>console.error(error),
        ()=>this.onSuccess.emit()
    )
  }
  close() {
    this.onClose.emit();
  }
}
